import React, { useState, useEffect, useRef, useMemo } from 'react';
import axiosInstance from '../axiosConfig';
import { cachedSessionGet } from '../sessionCache';
import DocViewer, { DocViewerRenderers } from "@cyntler/react-doc-viewer";
import Modal from '../Components/Modal';
import { motion } from 'framer-motion';
import { renderAsync } from 'docx-preview';
import { hasPermission } from '../Utils/permissions';
import { Link, useNavigate, useLocation } from 'react-router-dom';

function Documents() {
  const didInitialFetchRef = useRef(false);
  const [documents, setDocuments] = useState([]);
  const [documentImages, setDocumentImages] = useState([]);
  const [selectedDocument, setSelectedDocument] = useState(null);
  const [currentDocumentId, setCurrentDocumentId] = useState(null);
  const [currentUser, setCurrentUser ] = useState(null);
  const [message, setMessage] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [showUpdateModal, setShowUpdateModal] = useState(false);
  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [showImgModal, setShowImgModal] = useState(false);
  const [showUpdateImgModal, setShowUpdateImgModal] = useState(false);
  const [formDocumentData, setFormDocumentData] = useState({
    employee_code: '',
    contact_number: '',
    email: '',
    first_name: '',
    middle_name: '',
    last_name: '',
    father_first_name: '',
    father_middle_name: '',
    father_last_name: '',
    gender: '',
    date_of_birth: '',
    department: '',
    position: '',
    address: '',
    date_of_joining: '',
    offer_date: '',
  });
  const [formData, setFormData] = useState({
    id_proof: null,
    address_proof: null,
    pan_card: null,
    salary_slip: null,
    bank_statement: null,
    tax_return: null,
  });
  const [department, setDepartment] = useState('');
  const [ imageId, setImageId ] = useState ('');
  const [currentImageId, setCurrentImageId] = useState(null);
  const [selectedDocumentTypes, setSelectedDocumentTypes] = useState([]);
  const [popupopen, setPopupOpen] = useState (false);
  const [ selectedimage, setSelectedImage] = useState (null);
  const [documentTypes, setDocumentTypes] = useState({});
  const [uploadTypes, setUploadTypes] = useState({});
  const [selectedDocumentId, setSelectedDocumentId] = useState(null);
  const [filteredDocumentTypes, setFilteredDocumentTypes] = useState({});
  const [selectedDepartment, setSelectedDepartment] = useState(localStorage.getItem('selectedDepartment'));
  const [documentFilter, setDocumentFilter] = useState('');

  // Debounce backend search so backend isn't hit on every keystroke
  const [debouncedDocumentFilter, setDebouncedDocumentFilter] = useState(documentFilter);

  useEffect(() => {
    const t = setTimeout(() => {
      setDebouncedDocumentFilter(documentFilter);
    }, 400);
    return () => clearTimeout(t);
  }, [documentFilter]);

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const rowsPerPage = 10;
  const [previewFile, setPreviewFile] = useState(null);
  const [previewLabel, setPreviewLabel] = useState('');
  const [previewImage, setPreviewImage] = useState(null);
  const [downloadingPdf, setDownloadingPdf] = useState(false);
  const [error, setError] = useState(null);
  const docxContainerRef = useRef(null);
  const [branch, setBranch] = useState('');
  const storedBranchId = Number(localStorage.getItem('selectedBranchId'));
      const [activePath, setActivePath] = useState('');
            const location = useLocation();
       const [departments, setDepartments] = useState([]);
            const [departmentsOpen, setDepartmentsOpen] = useState(false);
            const [showAddressModal, setShowAddressModal] = useState(false);
const [addressLine1, setAddressLine1] = useState("");
const [addressLine2, setAddressLine2] = useState("");
const [selectedState, setSelectedState] = useState("");
const [pincode, setPincode] = useState("");
const [showSalaryModal, setShowSalaryModal] = useState(false);
const [epfEnabled, setEpfEnabled] = useState(true);
const [employerEpfEnabled, setEmployerEpfEnabled] = useState(true);
const [esicEnabled, setEsicEnabled] = useState(true);
const [teamhaltDoc, setTeamhaltDoc] = useState([]);
const [getALL, setGetAll] = useState([]);
const teamhaltInFlightRef = useRef(null);
const teamhaltLastKeyRef = useRef(null);


const [salary, setSalary] = useState({
  basic: "",
  da: "",
  hra: "",
  bonus: "",
  special_allowance: "",
  other1: "",
  other2: "",
});


// update fields
// Update fields
const handleSalaryChange = (e) => {
  const value = e.target.value === "" ? "" : Number(e.target.value);

  setSalary({
    ...salary,
    [e.target.name]: value,
  });
};


const safe = (v) => (v === "" || v === null || v === undefined ? 0 : Number(v));

const isSalaryAdded = Object.values(salary).some(
  (v) => v !== "" && v !== 0
);
// Gross Total
const grossTotal =
  safe(salary.basic) +
  safe(salary.da) +
  safe(salary.hra) +
  safe(salary.bonus) + 
  safe(salary.special_allowance) +
  safe(salary.other2); // OMIT other1 (deduction)

// EPF / ESIC
  const cappedBasic = Math.min(safe(salary.basic), 15000);

  const employeeEPF = epfEnabled ? Math.round(cappedBasic * 0.12) : 0;
  const employerEPF = epfEnabled ? Math.round(cappedBasic * 0.13) : 0;

const employeeESIC =
  esicEnabled && grossTotal <= 21000
    ? Math.round(grossTotal * 0.0075)
    : 0;

const employerESIC =
  esicEnabled && grossTotal <= 21000
    ? Math.round(grossTotal * 0.0325)
    : 0;

// Take Home (minus deduction)
const takeHome =
  grossTotal -
  employeeEPF -
  employeeESIC -
  safe(salary.other1);

// CTC
const ctc = grossTotal + employerEPF + employerESIC;


const saveSalaryData = () => {
  if (!isSalaryAdded) {
    setShowSalaryModal(false);
    return;
  }

  // 🔥 Save to form data AND shared storage (DP World only)
  const salaryToSave = {
    ...salary,
    gross_total: grossTotal,
    employee_epf: employeeEPF,
    employee_esic: employeeESIC,
    take_home: takeHome,
    employer_epf: employerEPF,
    employer_esic: employerESIC,
    ctc: ctc,
    epf_enabled: epfEnabled,
    esic_enabled: esicEnabled,
  };

  setFormDocumentData((prev) => ({
    ...prev,
    ...salaryToSave,
  }));

  // 🔥 Share salary across DP World Panipat docs
  if (isDPWorldPanipatBranch(selectedBranch)) {
    saveSharedSalary(salaryToSave);
  }

  setShowSalaryModal(false);
};



const [showUpdateSalaryModal, setShowUpdateSalaryModal] = useState(false);

const [updateSalary, setUpdateSalary] = useState({
  basic: 0,
  da: 0,
  hra: 0,
  bonus: 0,
  special_allowance: 0,
  other1: 0,
  other2: 0,
});

// 🔥 DP World Panipat Shared Salary Helpers
const SHARED_SALARY_KEY = 'dp_world_panipat_shared_salary';

const isDPWorldPanipatBranch = (branchName) => {
  return branchName === 'DP World Panipat';
};

const getSharedSalary = () => {
  try {
    const saved = localStorage.getItem(SHARED_SALARY_KEY);
    return saved ? JSON.parse(saved) : null;
  } catch {
    return null;
  }
};

const saveSharedSalary = (salaryData) => {
  try {
    localStorage.setItem(SHARED_SALARY_KEY, JSON.stringify(salaryData));
  } catch (error) {
    console.error('Failed to save shared salary:', error);
  }
};


const preloadSalaryUpdate = (data = {}) => {
  // 🔥 For DP World Panipat: Load shared salary first, then document data
  if (isDPWorldPanipatBranch(selectedBranch)) {
    const sharedSalary = getSharedSalary();
    if (sharedSalary) {
      setUpdateSalary({
        basic: Number(sharedSalary.basic) || '',
        da: Number(sharedSalary.da) || '',
        hra: Number(sharedSalary.hra) || '',
        bonus: Number(sharedSalary.bonus) || '',
        special_allowance: Number(sharedSalary.special_allowance) || '',
        other1: Number(sharedSalary.other1) || '',
        other2: Number(sharedSalary.other2) || '',
      });
      return; // Use shared values
    }
  }
  
  // Fallback: use document data
  setUpdateSalary({
    basic: Number(data.basic) || '',
    da: Number(data.da) || '',
    hra: Number(data.hra) || '',
    bonus: Number(data.bonus) || '',
    special_allowance: Number(data.special_allowance) || '',
    other1: Number(data.other1) || '',
    other2: Number(data.other2) || '',
  });
};

const handleUpdateSalaryChange = (e) => {
  const { name, value } = e.target;
  setUpdateSalary(prev => ({
    ...prev,
    [name]: Number(value) || 0,
  }));
};

// Gross Total
const {
  updateGrossTotal,
  updateEmployeeEPF,
  updateEmployerEPF,
  updateEmployeeESIC,
  updateEmployerESIC,
  updateTakeHome,
  updateCTC
} = useMemo(() => {

  const basic = Number(updateSalary.basic) || 0;
  const da = Number(updateSalary.da) || 0;
  const hra = Number(updateSalary.hra) || 0;
  const bonus = Number(updateSalary.bonus) || 0;
  const special = Number(updateSalary.special_allowance) || 0;
  const other1 = Number(updateSalary.other1) || 0; // ❌ deduction
  const other2 = Number(updateSalary.other2) || 0; // ✅ earning

  // ✅ GROSS (everything adds)
  const gross =
    basic + da + hra + bonus + special + other2;

  // ✅ EPF (basic capped at 15000)
  const cappedBasic = Math.min(basic, 15000);
  const empEPF = epfEnabled ? Math.round(cappedBasic * 0.12) : 0;
  const emplEPF = epfEnabled ? Math.round(cappedBasic * 0.13) : 0;

  // ✅ ESIC
  const empESIC =
    esicEnabled && gross <= 21000
      ? Math.round(gross * 0.0075)
      : 0;

  const emplESIC =
    esicEnabled && gross <= 21000
      ? Math.round(gross * 0.0325)
      : 0;

  // ✅ TAKE HOME
  const takeHome =
    gross - other1 - empEPF - empESIC;

  // ✅ CTC
  const ctc =
    gross + emplEPF + emplESIC;

  return {
    updateGrossTotal: gross,
    updateEmployeeEPF: empEPF,
    updateEmployerEPF: emplEPF,
    updateEmployeeESIC: empESIC,
    updateEmployerESIC: emplESIC,
    updateTakeHome: takeHome,
    updateCTC: ctc,
  };

}, [updateSalary, epfEnabled, esicEnabled]);



const updateOther1 = updateCTC + updateTakeHome;
const updateOther2 = updateCTC - updateTakeHome;


const saveUpdatedSalary = () => {
  const salaryToSave = {
    ...updateSalary,
    gross_total: updateGrossTotal,
    employee_epf: epfEnabled ? updateEmployeeEPF : 0,
    employee_esic: esicEnabled ? updateEmployeeESIC : 0,
    employer_epf: epfEnabled ? updateEmployerEPF : 0,
    employer_esic: esicEnabled ? updateEmployerESIC : 0,
    take_home: updateTakeHome,
    ctc: updateCTC,
    epf_enabled: epfEnabled,
    esic_enabled: esicEnabled,
  };

  setFormDocumentData(prev => ({
    ...prev,
    ...salaryToSave,
  }));

  // 🔥 Share salary across ALL DP World Panipat docs
  if (isDPWorldPanipatBranch(selectedBranch)) {
    saveSharedSalary(salaryToSave);
  }

  setShowUpdateSalaryModal(false);
};




const [showUpdateAddressModal, setShowUpdateAddressModal] = useState(false);

const [addressForm, setAddressForm] = useState({
  line1: "",
  line2: "",
  state: "",
  city: "",
  pincode: ""
});

const updateAddressObjectFromString = (addressStr) => {
  try {
    return JSON.parse(addressStr);
  } catch {
    return { line1: "", line2: "", city: "", state: "", pincode: "" };
  }
};

const saveUpdatedAddress = () => {
  setFormDocumentData({
    ...formDocumentData,
    address: JSON.stringify(addressForm)
  });

  setShowUpdateAddressModal(false);
};



  const handleImageClick = (image, type) =>{
    setSelectedImage(image);
    setPopupOpen(true);
  }
  
      useEffect(() => setActivePath(location.pathname), [location]);
  
  
  const handleDeleteImage = async (id, imageType) => {
    console.log("Deleting document image");
  
    if (window.confirm("Are you sure you want to delete this image?")) {
      try {
        await axiosInstance.delete(`/upload-documents/${id}/${imageType}/`);
  
        setDocumentImages((prevImages) => 
          prevImages.filter((image) => image.id !== id)
        );
  
        setPopupOpen(false);
        setSelectedImage(null);
      } catch (error) {
        console.error("Error deleting image:", error);
        alert("Failed to delete the image.");
      }
    }
  };

  
  useEffect(() => {
    const selectedBranch = localStorage.getItem('selectedBranch');
 
    if (selectedBranch === 'TEAMHALT') {

      const requestKey = `${currentPage}:${rowsPerPage}`;
                         
      // de-dupe: if already fetched the same page, skip
      if (teamhaltLastKeyRef.current === requestKey) return;
      teamhaltLastKeyRef.current = requestKey;
  
      // prevent overlapping requests
      if (teamhaltInFlightRef.current) return;
  
      teamhaltInFlightRef.current = true;
  
      axiosInstance
        .get('/teamhalt-documents/', {
          params: {
            page: currentPage,
            page_size: rowsPerPage,
            branch_name: 'TEAMHALT',
          },
        })
        .then((response) => {
          const docs = response?.data?.data || [];
          const pagination = response?.data?.pagination || {};
  
          setTeamhaltDoc(docs);
          setDocuments(docs);
          setTotalPages(pagination.total_pages || 1);
        })
        .catch((error) => {
          console.error(error);
          setTeamhaltDoc([]);
          setDocuments([]);
          setTotalPages(1);
        })
        .finally(() => {
          teamhaltInFlightRef.current = null;
        });
  
      return;
    }
  
    // Non-TEAMHALT: use existing /documents/ fetch
    fetchDocuments();
  }, [currentPage, debouncedDocumentFilter, storedBranchId]);

  
  
  
  const fetchDocuments = async () => {
    try {
      const res = await axiosInstance.get('/documents/', {
        params: {
          page: currentPage,
          limit: rowsPerPage,
          search: debouncedDocumentFilter, // 🔥 debounced backend global search
          department,
          branch_id: storedBranchId,
          status: 'enabled'
        }
      });
  
      setDocuments(res.data.data || []);
      setTotalPages(res.data.total_pages || 1);
  
    } catch (err) {
      console.error(err);
      setDocuments([]);
      setTotalPages(1);
    }
  };
  
  
  

  useEffect(() => {
    if (didInitialFetchRef.current) return;
    didInitialFetchRef.current = true;

    // Initial page data (guarded to avoid double API calls)
    cachedSessionGet(
      'upload-documents',
      () => axiosInstance.get('/upload-documents/').then(r => r.data)
    )
      .then((uploadDocuments) => {
        const image = uploadDocuments?.find(
          (document) => document.document === currentDocumentId
        );
        if (image) {
          setImageId(image.id);
        } else {
          setImageId(null);
        }
      })
      .catch((error) => {
        console.error(error);
      });

    cachedSessionGet(
      'document-types',
      () => axiosInstance.get('/document-types/').then(r => r.data),
      10 * 60 * 1000
    )
      .then((data) => setDocumentTypes(data))
      .catch((error) => {
        console.error(error);
      });

    cachedSessionGet('document-images', () => axiosInstance.get('/document-images/').then(r=>r.data), 10 * 60 * 1000).then((data)=> setUploadTypes(data))
      .then(response => {
        setUploadTypes(response.data);
      })
      .catch(error => {
        console.error(error);
      });

      // NOTE: Removed GET /get-image/ (large list) from mount.
      // Images for a single document are fetched lazily on modal open via GET /get-image/:id/.


    axiosInstance.get('/branch/')
      .then(response => {
        setBranch(response.data);
      })
      .catch(error => {
        console.error(error);
      });

    cachedSessionGet('permissions', () => axiosInstance.get('/permissions/').then(r=>r.data), 10 * 60 * 1000).then((data)=>{ localStorage.setItem('all_permissions', JSON.stringify(data)); })
      .then(res => {
        localStorage.setItem('all_permissions', JSON.stringify(res.data));
      })
      .catch(err => {
        console.error("Failed to fetch permissions:", err);
      });

    const userId = localStorage.getItem('id');
    if (userId) {
      axiosInstance.get(`/user/${userId}/`)
        .then(response => {
          setCurrentUser(response.data);
        })
        .catch(error => {
          console.error("Error fetching user details:", error);
        });
    }
  }, [currentDocumentId, selectedDepartment]);

  useEffect(() => {
    if (Array.isArray(documentTypes) && selectedDepartment) {
      const filteredTypes = documentTypes.filter((doc) =>
        doc.department.includes(selectedDepartment)
      );
      console.log("documentTypes:", documentTypes);
console.log("selectedDepartment:", selectedDepartment);

      setFilteredDocumentTypes(filteredTypes);
    } else {
      setFilteredDocumentTypes([]);
    }
  }, [documentTypes, selectedDepartment]);
   

  // useEffect(() => {
  //   if (documentTypes && selectedDepartment) {
  //     const filteredTypes = Object.keys(documentTypes).filter((key) => {
  //       return documentTypes[key].department_name === selectedDepartment;
  //     }).map((key) => documentTypes[key]);
  //     setFilteredDocumentTypes(filteredTypes);
  //   }
  // }, [documentTypes, selectedDepartment]);

  const handleDocumentChange = (event) => {
    const { name, value } = event.target;
    setFormDocumentData({
      ...formDocumentData,
      [name]: value,
    });
  };

  const handleDocumentSubmit = (event) => {
    event.preventDefault();
    const formData = new FormData();
    formData.append('email', formDocumentData.email);
    formData.append('first_name', formDocumentData.first_name);
    formData.append('middle_name', formDocumentData.middle_name);
    formData.append('last_name', formDocumentData.last_name);
    formData.append('contact_number', formDocumentData.contact_number);
    formData.append('employee_code', formDocumentData.employee_code);
    formData.append('department', department);
    formData.append('branch', selectedBranch);
    formData.append('date_of_birth', formDocumentData.date_of_birth);
    formData.append('gender', formDocumentData.gender);
    formData.append('father_first_name', formDocumentData.father_first_name);
    formData.append('father_middle_name', formDocumentData.father_middle_name);
    formData.append('father_last_name', formDocumentData.father_last_name);
    formData.append('position', formDocumentData.position);
    formData.append('address', formDocumentData.address);
    formData.append('date_of_joining', formDocumentData.date_of_joining);
    if (isSalaryAdded) {
      formData.append("basic", formDocumentData.basic);
      formData.append("da", formDocumentData.da);
      formData.append("hra", formDocumentData.hra);
      formData.append("bonus", formDocumentData.bonus);
      formData.append("special_allowance", formDocumentData.special_allowance);
      formData.append("other1", formDocumentData.other1);
      formData.append("other2", formDocumentData.other2);
  
      formData.append("gross_total", formDocumentData.gross_total);
      formData.append("employee_epf", formDocumentData.employee_epf);
      formData.append("employee_esic", formDocumentData.employee_esic);
      formData.append("take_home", formDocumentData.take_home);
      formData.append("employer_epf", formDocumentData.employer_epf);
      formData.append("employer_esic", formDocumentData.employer_esic);
      formData.append("ctc", formDocumentData.ctc);
  
      formData.append("epf_enabled", formDocumentData.epf_enabled);
      formData.append("esic_enabled", formDocumentData.esic_enabled);
    }
    axiosInstance.post('/documents/', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    .then(response => {
      setMessage('Document saved successfully!');
      setShowModal(false);
      setFormDocumentData({
        email: '',
        name: '',
        contact_number: '',
        employee_code: '',
        department: '',
        photo: '',
        date_of_birth: '',
        gender: '',
        father_first_name: '',
        father_middle_name: '',
        father_last_name: '',
        position: '',
        address: '',
        date_of_joining: '',
        offer_date: '',
      });
      setCurrentDocumentId(response.data.id);
    })
    .catch(error => {
      if (error.response && error.response.data) {
        const errorMessages = Object.entries(error.response.data)
          .map(([key, value]) => Array.isArray(value) ? value.join(', ') : value)
          .join(', ');
        setMessage(errorMessages);
      } else {
        setMessage('An error occurred. Please try again.');
      }
    });
  };
  

  const handleChange = (event) => {
    const { name, files } = event.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: files ? files[0] : prevFormData[name],
    }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const formData = new FormData();
  
    const fileInputs = document.querySelectorAll('input[name="file"]');
    const documentTypeInputs = document.querySelectorAll('input[name="document_type_id"]');
    const statusSelects = document.querySelectorAll('select[name="legend_status_display"]');
  
    const documentId = currentDocumentId;
  
    if (fileInputs.length === 0) {
      setMessage('No files selected.');
      return;
    }
  
    let criminalRecordCount = 0;
  
    fileInputs.forEach((fileInput, index) => {
      const file = fileInput.files[0];
      const docTypeId = documentTypeInputs[index].value;
      const docLabel = documentTypeInputs[index].getAttribute('data-label');
  
      if (file) {
        formData.append('files', file);
        formData.append('document_types', docTypeId);
  
        if (docLabel === 'Criminal Record') {
          const selectedStatus = statusSelects[criminalRecordCount]?.value || '';
          formData.append('legend_status_display', selectedStatus);
          criminalRecordCount += 1;
        } else {
          // For non-criminal records, still append an empty string to maintain array alignment
          formData.append('legend_status_display', '');
        }
      }
    });
  
    formData.append('document', documentId);
  
    axiosInstance.post('/document-images/images/', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
      .then((response) => {
        console.log(response.data);
        setMessage('Images uploaded successfully!');
        setShowImgModal(false);
        // Avoid full page reload (prevents backend refetch storm). Re-fetch current page.
        fetchDocuments();
      })
      .catch((error) => {
        console.error(error);
        setMessage('Error uploading images!');
      });
  };
  
  
  const handleImageUpdate = (event) => {
    event.preventDefault();
    const formData = new FormData();
  
    const fileInputs = document.querySelectorAll('input[name="file"]');
    const documentTypeInputs = document.querySelectorAll('input[name="document_type_id"]');
    const statusSelects = document.querySelectorAll('select[name="legend_status_display"]');
  
    let added = 0;
    let criminalCount = 0;
  
    fileInputs.forEach((input, index) => {
      if (input.files.length > 0) {
        const file = input.files[0];
        const docTypeId = documentTypeInputs[index].value;
        const docLabel = documentTypeInputs[index].getAttribute('data-label');
  
        formData.append('files', file);
        formData.append('document_types', docTypeId);
        added++;
  
        if (docLabel === 'Criminal Record') {
          const selectedStatus = statusSelects[criminalCount]?.value || '';
          formData.append('legend_status_display', selectedStatus);
          criminalCount += 1;
        } else {
          // For non-criminal records, keep list aligned
          formData.append('legend_status_display', '');
        }
      }
    });
  
    if (added === 0) {
      setMessage('Please select at least one file to update.');
      return;
    }
  
    formData.append('document', selectedDocumentId);
  
    axiosInstance.patch(`/document-images/update/`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
      .then((response) => {
        console.log(response.data);
        setMessage('Images updated successfully!');
        setShowUpdateImgModal(false);
        // Avoid full page reload (prevents backend refetch storm). Re-fetch current page.
        fetchDocuments();
      })
      .catch((error) => {
        console.error(error);
        setMessage('Error updating images!');
      });
  };
  

  const openDetailsModal = (document) => {
    console.log("Opening details modal for document:", document);
    setSelectedDocument(document);
    setShowDetailsModal(true);

    // Cache per document id to prevent repeated backend calls
    const cached = documentImagesCacheRef.current.get(document.id);
    if (cached) {
      setDocumentImages(cached);
      return;
    }

    axiosInstance.get(`/get-image/${document.id}/`)
      .then(response => {
        documentImagesCacheRef.current.set(document.id, response.data);
        setDocumentImages(response.data);
      })
      .catch(error => {
        console.error("Error fetching document images:", error);
      });
  };

  const openUpdateModal = (document, image) => {
    setFormDocumentData({
      employee_code: document.employee_code || '',
      contact_number: document.contact_number || '',
      email: document.email || '',
      first_name: document.first_name || '',
      middle_name: document.middle_name || '',
      last_name: document.last_name || '',
      father_first_name: document.father_first_name || '',
      father_middle_name: document.father_middle_name || '',
      father_last_name: document.father_last_name || '',
      date_of_birth: document.date_of_birth || '',
      gender: document.gender || '',
      photo: image || null,
      department: document.department || '',
      branch: document.branch || '',
  
      // ADD THESE ↓↓↓
      basic: document.basic || 0,
      da: document.da || 0,
      hra: document.hra || 0,
      special_allowance: document.special_allowance || 0,
      other1: document.other1 || 0,
      other2: document.other2 || 0,
      gross_total: document.gross_total || 0,
      employee_epf: document.employee_epf || 0,
      employee_esic: document.employee_esic || 0,
      employer_epf: document.employer_epf || 0,
      employer_esic: document.employer_esic || 0,
      take_home: document.take_home || 0,
      ctc: document.ctc || 0,
    });
  
    setCurrentDocumentId(document.id);
    setShowUpdateModal(true);
  };
  

  const handleUpdateDocumentSubmit = (event) => {
    event.preventDefault();
    axiosInstance.patch(`/documents/${currentDocumentId}/`, formDocumentData)
      .then(response => {
        setMessage('Document updated successfully!');
        setShowUpdateModal(false);
        setFormDocumentData({
          employee_code: '',
          contact_number: '',
          email: '',
          first_name: '',
          middle_name: '',
          last_name: '',
          father_first_name: '',
          father_middle_name: '',
          father_last_name: '',
          date_of_birth: '',
          gender: '',
          photo: '',
          department: '',
          branch: '',
        });
      })
      .catch(error => {
        setMessage(JSON.stringify(error.response.data));
      });
  };

  const handleDelete = (id) => {
    if (window.confirm("Are you sure you want to Delete  this document?")) {
        axiosInstance.patch(`/status-change/${id}/disabled/`)
            .then(response => {
                setMessage('Document Deleted Successfully!');
                // Avoid full reload (backend refetch storm). Re-fetch current page.
                fetchDocuments();
            })
            .catch(error => {
              if (error.response.data) {
                const errorMessages = Object.keys(error.response.data).map(key => {
                  return error.response.data[key].join(', ');
                }).join(', ');
                setMessage(errorMessages);
              } else {
                setMessage('An error occurred. Please try again.');
              }
            });
          }
        };

        const handleCriminalRecordDownload = (documentId) => {
          setDownloadingPdf(true);
        
          axiosInstance.get(`download-criminal/${documentId}/`, {
            responseType: 'blob',
          })
          .then((res) => {
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'Criminal_Record_With_Intro.pdf');
            document.body.appendChild(link);
            link.click();
            link.remove();
            setDownloadingPdf(false);
          })
          .catch((error) => {
            console.error('Failed to download Criminal Record PDF:', error);
            setDownloadingPdf(false);
          });
        };

const handleDownloadImages = (documentId) => {
  axiosInstance.get(`/download-document-images/${documentId}/`, {
    responseType: 'blob',
  })
  .then((response) => {
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const a = document.createElement('a');
    a.href = url;
    a.download = `document_images_${documentId}.zip`;
    a.click();
    window.URL.revokeObjectURL(url);
  })
  .catch((error) => {
    if (error.response.data) {
      const errorMessages = Object.keys(error.response.data).map(key => {
        return error.response.data[key].join(', ');
      }).join(', ');
      setMessage(errorMessages);
    } else {
      setMessage('An error occurred. Please try again.');
    }
  });
};


const handleDownloadSingleImage = (imageId, documentType) => {
  const url = `/document-images/download-by-id/${imageId}/`;

  axiosInstance.get(url, { responseType: 'blob' })
    .then(response => {
      const contentType = response.headers['content-type'];
      let fileExtension = 'jpg';

      if (contentType === 'application/pdf') fileExtension = 'pdf';
      else if (contentType === 'image/png') fileExtension = 'png';
      else if (contentType === 'image/webp') fileExtension = 'webp';
      else if (contentType === 'image/jpeg') fileExtension = 'jpg';
      else if (contentType === 'application/msword') fileExtension = 'doc';
      else if (contentType === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document') fileExtension = 'docx';

      const blobUrl = window.URL.createObjectURL(new Blob([response.data]));

      const link = document.createElement('a');
      link.href = blobUrl;
      link.setAttribute('download', `document_${imageId}.${fileExtension}`);
      document.body.appendChild(link);
      link.click();
      link.remove();

      setPopupOpen(false);
    })
    .catch(error => {
      setMessage('An error occurred while downloading.');
    });
};

useEffect(() => {
  const selectedDepartment = localStorage.getItem('selectedDepartment');
  if (selectedDepartment) {
    setDepartment(selectedDepartment);
  }
}, []);

  useEffect(() => {
    const selectedDocumentTypes = localStorage.getItem('selectedDocumentTypes');
    if (selectedDocumentTypes) {
      setSelectedDocumentTypes(selectedDocumentTypes.split(','));
    }
  }, []);

  const selectedBranch = localStorage.getItem('selectedBranch');

  const fetchDocumentTypes = (branchName) => {
      axiosInstance.get(`/document-types/from-branch/${branchName}/`)
        .then((response) => {
          setUploadTypes(response.data);
        })
        .catch((error) => {
          console.error('Error fetching document types:', error);
          setMessage('Error fetching document types!');
        });
    };

  const isBranchSelected = localStorage.getItem('selectedBranch') !== 'null';  
  const image = documentImages.find(image => image.id === currentImageId);
  const groupByCategory = (documents) => {
    const grouped = {};
    Object.keys(documents).forEach(key => {
      const doc = documents[key];
      const category = doc.category || 'Others';
      if (!grouped[category]) {
        grouped[category] = [];
      }
      grouped[category].push(doc);
    });
    return grouped;
  };

  const filteredDocuments = documents.filter((doc) => {
    const search = documentFilter.toLowerCase();
  
    const fullName = `${doc.first_name || ''} ${doc.middle_name || ''} ${doc.last_name || ''}`.toLowerCase();
  
    return (
      doc.employee_code?.toLowerCase().includes(search) ||
      fullName.includes(search)
    );
  });
  
  const sortedDocuments = [...filteredDocuments].sort((a, b) => {
    const getValue = (code) => {
      const match = code?.match(/\d+/);
      return match ? parseInt(match[0], 10) : (code || '').toLowerCase();
    };
  
    return getValue(b.employee_code) - getValue(a.employee_code);
  });
  
 
  
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  // Cache images-per-document for details modal.
  // Prevents repeated calls to GET /get-image/:id/ when user reopens the same modal.
  const documentImagesCacheRef = useRef(new Map());

  const groupedImages = documentImages.reduce((acc, image) => {
    const [category, name] = image.document_type_info.split(' - ');
    const parsedCategory = category || 'Others';
    const parsedName = name || 'Document';
  
    const formattedImage = {
      ...image,
      parsedCategory,
      parsedName,
    };
  
    if (!acc[parsedCategory]) acc[parsedCategory] = [];
    acc[parsedCategory].push(formattedImage);
    return acc;
  }, {});

  const handleFileClick = (file, label) => {
    let fileURL;
  
    if (file instanceof File || file instanceof Blob) {
      fileURL = URL.createObjectURL(file);
    } else if (typeof file === 'string') {
      // Ensure HTTPS
      const secureFile = file.replace(/^http:\/\//i, 'https://');
      fileURL = secureFile.startsWith('http') ? secureFile : `${process.env.REACT_APP_API_BASE_URL}${secureFile}`;
    } else {
      console.error('Unsupported file type');
      return;
    }
  
    if (/\.pdf(\?.*)?$/i.test(fileURL)) {
      window.open(fileURL, '_blank');
    } else {
      setPreviewFile(fileURL);
      setPreviewLabel(label);
    }
  };
  
  const renderFilePreview = (fileUrl, label, imageId, imageType) => {
    if (!fileUrl) return null;
  
    // Determine the full URL
    const secureFileUrl = fileUrl.startsWith('http')
      ? fileUrl
      : `${process.env.REACT_APP_API_BASE_URL}${fileUrl}`;
  
    // File type checks
    const isImage = /\.(jpg|jpeg|png|webp|gif)$/i.test(fileUrl);
    const isPDF = /\.pdf(\?.*)?$/i.test(fileUrl);
    const isDoc = /\.(doc|docx)$/i.test(fileUrl);
  
    // Click handler
    const handleClick = () => handleImageClick({ id: imageId, url: secureFileUrl, imageType });
  
    return (
      <div key={label + imageId} style={{ textAlign: 'center', margin: '5px' }}>
        {isImage ? (
          <img
            src={secureFileUrl}
            alt={label}
            style={{ width: '60px', height: '60px', cursor: 'pointer' }}
            onClick={handleClick}
          />
        ) : isPDF ? (
          <div
            style={{ fontSize: '40px', color: 'red', cursor: 'pointer', fontWeight: 'bold' }}
            onClick={handleClick}
          >
            <i className="fas fa-file-pdf"></i>
          </div>
        ) : isDoc ? (
          <div
            style={{ fontSize: '40px', color: 'blue', cursor: 'pointer', fontWeight: 'bold' }}
            onClick={handleClick}
          >
            <i className="fas fa-file-word"></i>
          </div>
        ) : (
          <div
            style={{ fontSize: '16px', color: 'gray', cursor: 'pointer', fontWeight: 'bold' }}
            onClick={handleClick}
          >
            <i className="fas fa-file-alt"></i>
            <div style={{ fontSize: '12px', color: '#666' }}>Unknown File</div>
          </div>
        )}
      </div>
    );
  };
  

  useEffect(() => {
    const loadDocx = async () => {
      if (!previewFile) return;
      if (!/\.(docx?)$/i.test(previewFile)) return;
      if (!docxContainerRef.current) return;

      // Avoid re-render thrash for the same preview
      const container = docxContainerRef.current;
      container.innerHTML = "";

      let secureUrl = previewFile;
      if (secureUrl.startsWith('http://')) {
        secureUrl = secureUrl.replace('http://', 'https://');
      }

      try {
        const response = await fetch(secureUrl);
        const blob = await response.blob();
        await renderAsync(blob, container);
      } catch (error) {
        console.error("Error rendering DOCX:", error);
      }
    };

    loadDocx();
  }, [previewFile]);
  

  const handleIconClick = (documentId) => {
    localStorage.setItem('selectedDocumentId', documentId);
  };

  const handleSendUploadInvite = async (documentId) => {
    try {
      setMessage('');

      const response = await axiosInstance.post(
        `documents/${documentId}/send-upload-invite/`,
        {}
      );

      // API response example:
      // {
      //   "status": "sent",
      //   "expires_at": "...",
      //   "token": "..."
      // }
      const status = response?.data?.status;

      // Only show `sent` in alert (as requested)
      alert(status === 'sent' ? 'sent' : status || 'sent');
      setMessage('Upload invite sent.');
    } catch (error) {
      console.error('Failed to send upload invite:', error);
      const msg =
        error?.response?.data
          ? JSON.stringify(error.response.data)
          : 'Failed to send upload invite.';
      setMessage(msg);
    }
  };

  const verificationStatus = localStorage.getItem('verification_status');

  const handleDownloadPDF = async () => {
    const selectedDocumentId = localStorage.getItem('selectedDocumentId');
    if (!selectedDocumentId) {
      setError('No document selected. Please select a document to download.');
      return;
    }
    setDownloadingPdf(true);
    try {
      const response = await axiosInstance.get(`/documents/download/${selectedDocumentId}/`, {
        responseType: 'blob', // Important: responseType as blob
      });
      const pdfBlob = new Blob([response.data], { type: 'application/pdf' });
      const pdfUrl = window.URL.createObjectURL(pdfBlob);
      window.open(pdfUrl, '_blank'); // Open the PDF URL directly
      setDownloadingPdf(false);
    } catch (error) {
      setError('Failed to download PDF. Please try again.');
      console.error('Error downloading PDF:', error);
      setDownloadingPdf(false);
    }
  };

  const handleOfferLetterDownload = async (documentId) => {
    try {
      setDownloadingPdf(true);
  
      const response = await axiosInstance.get(
        `/documents/${documentId}/offer-letter/`,
        {
          responseType: 'blob',
        }
      );
  
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `Offer_Letter_${documentId}.pdf`);
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      console.error('Error downloading offer letter:', error);
      alert('Failed to download Offer Letter. Please try again.');
    } finally {
      setDownloadingPdf(false);
    }
  };
  

  const handleAppointmentLetterDownload = async (documentId) => {
    try {
      setDownloadingPdf(true);
  
      const response = await axiosInstance.get(`/appointment-letter/${documentId}/`, {
        responseType: "blob", 
      });
  
      const blob = new Blob([response.data], { type: "application/pdf" });
  
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = `Appointment_Letter_${documentId}.pdf`;
      link.click();
  
    } catch (err) {
      console.error("Error downloading appointment letter", err);
    } finally {
      setDownloadingPdf(false);
    }
  };
  
  const handleDPWorldAppointmentLetterDownload = async (documentId) => {
    try {
      setDownloadingPdf(true);
  
      const response = await axiosInstance.get(`/download-hindi-appointment/${documentId}/`, {
        responseType: "blob",
      });
  
      const blob = new Blob([response.data], { type: "application/pdf" });
  
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = `Hindi_Appointment_Letter_${documentId}.pdf`;
      link.click();
  
    } catch (err) {
      console.error("Error downloading Hindi Appointment Letter", err);
    } finally {
      setDownloadingPdf(false);
    }
  };
  
  
  return (
 <div className="dashboard-wrapper">
          {/* Left Sidebar */}
          <div className="dashboard-sidebar">
  <div className="sidebar-header">
    <img src="/logo.png" alt="Logo" className="sidebar-logo" />
  </div>

  <nav className="sidebar-nav">
    <Link
      to="/admin-dashboard"
      className={`sidebar-link ${activePath === '/admin-dashboard' ? 'active' : ''}`}
    >
      <i className="fas fa-home"></i> Dashboard
    </Link>

    {currentUser?.role_name === 'admin' && (
      <Link
        to="/users"
        className={`sidebar-link ${activePath === '/users' ? 'active' : ''}`}
      >
        <i className="fas fa-users"></i> Users
      </Link>
    )}

    {/* Simplified Departments Link */}
    <Link
      to="/departments"
      className={`sidebar-link ${activePath === '/departments' ? 'active' : ''}`}
    >
      <i className="fas fa-file-alt"></i> Departments
    </Link>
  </nav>
</div>
  
          <div
                  className="dashboard-main"
                  style={{
                    display: 'flex',
                    gap: '20px',
                    flexWrap: 'nowrap',
                    alignItems: 'flex-start',
                    padding: '20px',
                  }}
                >
                   <div className="dashboard-content" style={{ flex: 3 }}>
                  
                  <h2>Employees</h2>
                  <div>
                               <motion.div className="dashboard-card">
                                            {localStorage.getItem('selectedBranch') !== 'null' &&
  (hasPermission('Document Create') || (currentUser && (currentUser.role_name === 'admin' || currentUser.role_name === 'subadmin' ))) && (
   
     <button
  className="view-all-btn"
  title="Add Employees"
onClick={() => window.location.href = '/add-employee'}
>
  <span>+ Add Employees</span>
</button>

)}
                                          </motion.div>        


<Modal
  isOpen={showUpdateImgModal}
  onClose={() => setShowUpdateImgModal(false)}
>
  <form onSubmit={handleImageUpdate} className="update-documents">

    {/* Header */}
    <div className="update-documents-header">
      <h2>Update Documents</h2>
      <button
        type="button"
        className="close-modal-btn"
        onClick={() => setShowUpdateImgModal(false)}
      />
    </div>
    <hr />

    {/* Body */}
    <div className="update-documents-body">
      {filteredDocumentTypes.length === 0 ? (
        <p className="loading">Loading documents…</p>
      ) : (
        Object.entries(groupByCategory(filteredDocumentTypes))
          .sort(([a], [b]) => {
            const order = [
              'KYC Documents',
              'Joining Documents',
              'Compliance Documents',
            ];
            return (
              (order.indexOf(a) === -1 ? 99 : order.indexOf(a)) -
              (order.indexOf(b) === -1 ? 99 : order.indexOf(b))
            );
          })
          .map(([category, docs]) => {
            const preferredOrder = [
              'EPF Form',
              'ESIC Form',
              'KYC Verification',
              'Criminal Record',
            ];

            const sortedDocs = [...docs].sort((a, b) => {
              return (
                (preferredOrder.indexOf(a.name) === -1
                  ? 99
                  : preferredOrder.indexOf(a.name)) -
                (preferredOrder.indexOf(b.name) === -1
                  ? 99
                  : preferredOrder.indexOf(b.name))
              );
            });

            return (
              <fieldset key={category} className="document-section">
                <legend className="document-section-title">
                  {category || 'Others'}
                </legend>

                <div className="document-list">
                  {sortedDocs.map((doc) => (
                    <div key={doc.id} className="document-item">
                      <label className="document-label">{doc.name}</label>

                      {doc.name === 'Offer Letter' ||
                      doc.name === 'Appointment Letter' ? (
                        <input
                          type="text"
                          value="No file required"
                          disabled
                          className="document-input disabled-input"
                        />
                      ) : doc.name === 'KYC Verification' ? (
                        <div className="kyc-container">
                          {verificationStatus === 'verified' ? (
                            <span className="kyc-file">
                              📄 BGV-Report.pdf
                            </span>
                          ) : (
                            <span className="kyc-missing">
                              Report not available
                            </span>
                          )}
                        </div>
                      ) : (
                        <>
                          <input
                            type="file"
                            name="file"
                            className="document-input"
                          />
                          <input
                            type="hidden"
                            name="document_type_id"
                            value={doc.id}
                            data-label={doc.name}
                          />

                          {doc.name === 'Criminal Record' && (
                            <select
                              name="legend_status_display"
                              className="document-select"
                            >
                              <option value="">
                                -- Select Status --
                              </option>
                              <option value="✓ Clear">✓ Clear</option>
                              <option value="⚠ Minor Discrepancy">
                                ⚠ Minor Discrepancy
                              </option>
                              <option value="✘ Major Discrepancy">
                                ✘ Major Discrepancy
                              </option>
                              <option value="ℹ Unable To Verify">
                                ℹ Unable To Verify
                              </option>
                            </select>
                          )}
                        </>
                      )}
                    </div>
                  ))}
                </div>
              </fieldset>
            );
          })
      )}
    </div>

    {/* Footer */}
    <div className="update-documents-footer">
      <button type="submit" className="submit-all-btn">
        Submit
      </button>
    </div>

    {message && <p className="update-documents-message">{message}</p>}
  </form>
</Modal>

<div>
<div style={{ marginBottom: '10px', textAlign: 'right' }}>
<input
  type="text"
  placeholder="Filter by Employee Code or Name"
  value={documentFilter}
  onChange={(e) => {
    setDocumentFilter(e.target.value);
    setCurrentPage(1); // 🔥 REQUIRED
  }}
/>


</div>


      <table className="striped-table">
  <thead>
    <tr>
      <th className='doc-table'>Employee Code</th>
      <th className='doc-name'>Name</th>
      <th>Department</th>
      <th>Branch</th>
      <th>Actions</th>
    </tr>
  </thead>
  <tbody>
  {documents.length > 0 ? (
    documents.map((document, index) => (
      <tr key={document.id || index}>
        <td>{document.employee_code}</td>
        <td>
          {document.first_name} {document.middle_name} {document.last_name}
        </td>
        <td>{document.department}</td>
        <td>{document.branch}</td>
        <td>

          {/* Update Document */}
          {(hasPermission("Update Document") ||
            (currentUser &&
              (currentUser.role_name === 'admin' ||
               currentUser.role_name === 'subadmin'))) &&
            isBranchSelected && (
              <i
                className="fas fa-edit"
                title="Update"
                onClick={() => {
                  handleIconClick(document.id);
                  window.location.href = '/update-employee';
                }}
                style={{ cursor: 'pointer', marginRight: '10px' }}
              />
            )}

          {/* View */}
          {(hasPermission("View Documents") ||
            (currentUser &&
              (currentUser.role_name === 'admin' ||
               currentUser.role_name === 'subadmin'))) && (
              <i
                className="fas fa-eye"
                title="View"
                onClick={() => {
                  handleIconClick(document.id);
                  localStorage.setItem(
                    'verification_status',
                    document.verification_status
                  );
                  localStorage.setItem(
                    'selected_document_for_details',
                    JSON.stringify(document)
                  );
                  window.location.href = '/employee-details';
                }}
                style={{ cursor: 'pointer', marginRight: '10px' }}
              />
            )}

          {/* Delete */}
          {(hasPermission("Delete Documents") ||
            (currentUser && currentUser.role_name === 'admin')) && (
              <i
                className="fas fa-trash"
                title="Delete"
                onClick={() => {
                  handleIconClick(document.id);
                  handleDelete(document.id);
                }}
                style={{ cursor: 'pointer', marginRight: '10px' }}
              />
            )}

          {/* Send Upload Invite */}
          {(currentUser &&
            (currentUser.role_name === 'admin' ||
              currentUser.role_name === 'subadmin' ||
              currentUser.role_name === 'manager') &&
            isBranchSelected) && (
            <i
              className="fas fa-envelope"
              title="Send mail to upload documents"
              onClick={() => handleSendUploadInvite(document.id)}
              style={{ cursor: 'pointer', marginRight: '10px' }}
            />
          )}

          {/* Upload Image (admin flow) */}
          {(hasPermission("Update Document") ||
            (currentUser &&
              (currentUser.role_name === 'admin' ||
               currentUser.role_name === 'subadmin'))) &&
            isBranchSelected && (
              <i
                className="fas fa-upload"
                title="Upload Image"
                onClick={() => {
                  handleIconClick(document.id);
                  setCurrentDocumentId(document.id);
                  setSelectedDocumentId(document.id);
                  setFormDocumentData({
                    ...formDocumentData,
                    department: document.department,
                  });
                  localStorage.setItem(
                    'verification_status',
                    document.verification_status
                  );
                  setShowUpdateImgModal(true);
                }}
                style={{ cursor: 'pointer', marginRight: '10px' }}
              />
            )}

          {/* BGV */}
          {(hasPermission("BGV Access") ||
            (currentUser &&
              (currentUser.role_name === 'admin' ||
               currentUser.role_name === 'subadmin'))) && (
              <i
                className="fas fa-check"
                title="BGV"
                onClick={() => {
                  handleIconClick(document.id);
                  window.location.href = '/bgv';
                }}
                style={{ cursor: 'pointer', marginRight: '10px' }}
              />
            )}

        </td>
      </tr>
    ))
  ) : (
    <tr>
      <td colSpan="5" style={{ textAlign: 'center' }}>
        No records found
      </td>
    </tr>
  )}
</tbody>
</table>

      {/* Pagination Controls */}
      {totalPages > 1 && (
        <div style={{ display: 'flex', justifyContent: 'center', marginTop: '15px' }}>
          <button
            onClick={() => handlePageChange(currentPage - 1)}
            disabled={currentPage === 1}
            style={{
              padding: '0px 10px',
              margin: '0 5px',
              cursor: currentPage === 1 ? 'not-allowed' : 'pointer',
              backgroundColor: '#ddd',
              border: 'none',
              borderRadius: '5px',
              fontSize: '12px'
            }}
          >
            Previous
          </button>
          <span style={{ padding: '3px 12px', fontSize: '12px' }}>
            Page {currentPage} of {totalPages}
          </span>
          <button
            onClick={() => handlePageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
            style={{
              padding: '0px 10px',
              margin: '0 5px',
              cursor: currentPage === totalPages ? 'not-allowed' : 'pointer',
              backgroundColor: '#ddd',
              border: 'none',
              borderRadius: '5px',
              fontSize: '12px'
            }}
          >
            Next
          </button>
        </div>
      )}
    </div>
    {previewFile && (
  <div className="modal-overlay" onClick={() => setPreviewFile(null)}>
    <div className="preview-modal-content" onClick={(e) => e.stopPropagation()}>
    <div className="popup-header">
              <span className="close-icon"onClick={() => setPreviewFile(null)}>
                ×
              </span>
            </div>
      <h4>{previewLabel}</h4>

      {/\.(pdf)$/i.test(previewFile) ? (
  <iframe
    src={previewFile}
    width="100%"
    height="500px"
    title="PDF Viewer"
    frameBorder="0"
  />
) : /\.(docx?)$/i.test(previewFile) ? (
  <div
    ref={docxContainerRef}
    style={{
      maxHeight: '500px',
      overflow: 'auto',
      border: '1px solid #ccc',
      padding: '10px',
    }}
  />
) : (
  <img
    src={previewFile}
    alt={previewLabel}
    style={{ maxWidth: '100%', maxHeight: '400px' }}
  />
)}
      {previewImage && (
  <button
    className="download-button"
    onClick={() =>
      handleDownloadSingleImage(previewImage.id, previewImage.document_type?.name)
    }
  >
    Download
  </button>
)}
    </div>
  </div>
)}
</div>
</div>
</div>
</div>
  );
}

export default Documents;
